import { getPrivacyTerms } from '../constants/privacyTerms';
import { useI18n } from '../i18n';

function PrivacyAgreement({ checked, onChange, disabled = false }) {
  const { t, lang } = useI18n();
  const terms = getPrivacyTerms(lang);

  return (
    <div className="privacy-agreement">
      <p className="form-label privacy-agreement-label">
        {t('registration.privacy.label')} <span className="required">*</span>
      </p>
      <div
        className="privacy-terms-box"
        tabIndex={0}
        role="document"
        aria-label={t('registration.privacy.termsAria')}
      >
        <p className="privacy-terms-intro">{terms.intro}</p>
        {terms.sections.map((section) => (
          <section key={section.title} className="privacy-terms-section">
            <h3 className="privacy-terms-heading">{section.title}</h3>
            <p className="privacy-terms-body">{section.body}</p>
          </section>
        ))}
      </div>
      <label className={`privacy-checkbox${disabled ? ' disabled' : ''}`}>
        <input
          type="checkbox"
          className="privacy-checkbox-input"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="privacy-checkbox-text">{terms.agreementLabel}</span>
      </label>
    </div>
  );
}

export default PrivacyAgreement;
